class KneePadsUpsell extends HTMLElement {
    connectedCallback() {
        const data = JSON.parse(this.getAttribute('data-upsell') || '{}');
        const { default: defaultItem, upsell, mainProductVariants } = data;

        this.defaultItem = defaultItem;
        this.upsell = upsell;
        this.mainProductVariants = mainProductVariants || [];

        const isAvailable = upsell.available !== false;
        const buttonText = isAvailable ? upsell.button_text : "Sold out";
        const buttonDisabled = isAvailable ? '' : 'disabled';
        const buttonClass = isAvailable ? 'add-btn' : 'add-btn sold-out';

        this.innerHTML = `
        <div class="knee-pads-container">
          <div class="included">
            <span>${defaultItem.title}</span>
          </div>
          <div class="upsell">
            <div class="left">
                ${upsell.image
                ? `<img src="${upsell.image}" alt="${upsell.title}" loading="lazy" width="100%" />`
                : ''
            }
            </div>
            <div class="content">
                <div class="top-content">
                    <p class="upgrade badge">${upsell.label}</p>

                    <div class="price">
                        <s>${upsell.original_price}</s>
                        <span class="discounted">$${upsell.discounted_price}</span>
                    </div>
                </div>
                <div class="title">${upsell.title}</div>
                <div class="bottom_content">
                    <div class="info">
                        <div class="desc">${upsell.description}</div>
                    </div>
                    <button class="${buttonClass}" ${buttonDisabled}>${buttonText}</button>
                </div>
                <div class="upsell-error-message" style="display: none;"></div>
            </div>

          </div>
        </div>
      `;

        const addButton = this.querySelector('.add-btn');
        if (addButton && isAvailable) {
            addButton.addEventListener('click', () => {
                this.addToCart(upsell.id)
            });
        }
    }

    async findCurrentVariantOnCart() {
        const cart = await fetch("/cart.js", {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        });
        const cart_data = await cart.json();

        const currentVariant = cart_data.items.find(item => item.id === this.defaultItem.id);

        if (currentVariant) {
            return currentVariant;
        } else {
            return null;
        }
    }

    getCurrentVariantId() {
        // Try to get the variant ID from the URL (?variant=123456)
        const urlParams = new URLSearchParams(window.location.search);
        const variantFromUrl = urlParams.get('variant');

        if (variantFromUrl) {
            return variantFromUrl;
        }

        // Fallback: try to get it from the form
        const variantPicker = document.querySelector('variant-picker');
        if (variantPicker) {
            const formReference = variantPicker.getAttribute('form');
            if (formReference) {
                const form = document.querySelector(`#${formReference}`);
                if (form && form.elements["id"]) {
                    return form.elements["id"].value;
                }
            }
        }

        // Fallback: look for hidden input with name="id" in the product form
        const productForm = document.querySelector('form[action*="/cart/add"]');
        if (productForm) {
            const idInput = productForm.querySelector('input[name="id"]');
            if (idInput) {
                return idInput.value;
            }
        }

        return null;
    }

    isCurrentVariantAvailable() {
        const currentId = this.getCurrentVariantId();
        if (!currentId) return false;

        const variant = this.mainProductVariants.find(
            v => v.id.toString() === currentId.toString()
        );

        return variant ? variant.available : false;
    }

    showError(message) {
        const errorElement = this.querySelector('.upsell-error-message');
        if (errorElement) {
            errorElement.textContent = message;
            errorElement.style.display = 'block';

            // Auto-hide after 5 seconds
            setTimeout(() => {
                this.hideError();
            }, 5000);
        }
    }

    hideError() {
        const errorElement = this.querySelector('.upsell-error-message');
        if (errorElement) {
            errorElement.style.display = 'none';
            errorElement.textContent = '';
        }
    }

    setButtonLoading(isLoading) {
        const button = this.querySelector('.add-btn');
        if (button) {
            if (isLoading) {
                button.dataset.originalText = button.textContent;
                button.textContent = 'Adding...';
                button.disabled = true;
            } else {
                button.textContent = button.dataset.originalText || this.upsell.button_text;
                button.disabled = false;
            }
        }
    }

    async addToCart(id) {
        this.hideError();

        // Check if the current variant is available before attempting to add
        if (!this.isCurrentVariantAvailable()) {
            this.showError('Please select an available size/option before adding the upgrade.');
            return;
        }

        const currentId = this.getCurrentVariantId();

        const items = [{
            id,
            quantity: 1,
        },
        {
            id: currentId,
            quantity: 1
        }];

        this.setButtonLoading(true);

        try {
            const response = await fetch("/cart/add.js", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    items,
                    sections:
                        "cart-count, variant-added, sections--17218834694186__cart-drawer",
                }),
            });

            if (!response.ok) {
                const errorData = await response.json();

                // Parse Shopify's error response
                if (errorData.description) {
                    this.showError(errorData.description);
                } else if (errorData.message) {
                    this.showError(errorData.message);
                } else {
                    this.showError('Unable to add to cart. Please select an available option.');
                }

                this.setButtonLoading(false);
                return;
            }

            const data = await response.json();
            const cart = await fetch("/cart.js", {
                method: "GET",
                headers: { "Content-Type": "application/json" },
            });
            const cart_data = await cart.json();

            document.dispatchEvent(
                new CustomEvent("cart:change", {
                    bubbles: true,
                    detail: {
                        baseEvent: "line-item:change",
                        cart: cart_data,
                    },
                })
            );

            document.documentElement.dispatchEvent(
                new CustomEvent("cart:refresh", {
                    bubbles: true,
                    detail: {
                        baseEvent: "variant:add",
                        cart: cart_data,
                    },
                })
            );

            // Update button to show added state
            const button = this.querySelector('.add-btn');
            if (button) {
                button.textContent = 'Added!';
                button.classList.add('added');
                button.disabled = true;
            }

            document.querySelector('[aria-controls="cart-drawer"]').click();
            return data;
        } catch (error) {
            console.error("Error:", error);
            this.showError('An error occurred. Please try again.');
            this.setButtonLoading(false);
        }
    }
}

customElements.define('knee-pads-upsell', KneePadsUpsell);